import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import NavigationBars from '../../components/HOC/withNavigationBars';
import Entities from './Entities/Entities';
import Centers from './Centers/Centers';
import { colors } from 'kangarootime-ui';
import './Admin.css';

function TabContainer (props) {
  return (
    <Typography component='div' className='admin-material-tab-content'>
      {props.children}
    </Typography>
  );
}
const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tabsIndicator: {
    backgroundColor: colors.brand_1
  },
  tabRoot: {
    minWidth: 48,
    fontWeight: 500,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    marginRight: 4,
    backgroundColor: '#FFFFFF',
    '&:hover': {
      color: colors.brand_1,
      opacity: 1
    },
    '&$tabSelected': {
      backgroundColor: '#FFFFFF',
      color: colors.brand_1
    }
  },
  tabSelected: {
    borderBottom: `2px solid ${colors.brand_1}`
  }
});

class Admin extends Component {
  constructor (props) {
    super(props);
    this.state = {
      value: 0
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render () {
    const { classes } = this.props;
    return (
      <NavigationBars>
        <Row>
          <Col md={12} className='scheduling-left-gutter'>
            <div>
              <Tabs value={this.state.value} onChange={this.handleChange} classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}>
                <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label='Entities' />
                <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label='Centers' />
                <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label='Item Three' />
              </Tabs>
              {this.state.value === 0 && <TabContainer><Entities /></TabContainer>}
              {this.state.value === 1 && <TabContainer><Centers /></TabContainer>}
              {this.state.value === 2 && <TabContainer>item three</TabContainer>}
            </div>
          </Col>
        </Row>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    centerId: state.identity.centerId
  };
}

function mapDispatchToProps (dispatch) {
  return {};
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Admin)
);
